/* @generated */
const motion = {
  Easing: {
    Linear: "linear",
    Enter: "cubic-bezier(0, 0.6, 0, 1)",
    Leave: "cubic-bezier(1, 0, 1, 0.5)",
    Transition: "cubic-bezier(0.66, 0, 0, 1)"
  },
  /**
   * These are modified values from tokens-original. The naming was confusing, so went with a more easy to grok scale.
   * There is no Design System value for this, so we're just using the values from the original tokens. This is because
   *  design doesn't believe Duration is a valuable token to share, but it is useful internally, so we put it here.
   */
  Duration: {
    None: "0s",
    Fast: "125ms",
    Medium: "333ms",
    Slow: "708ms"
  }
};
export {
  motion
};
